// extracted by mini-css-extract-plugin
module.exports = {"icon_success":"icon_success___22PXt"};